import React from "react";

const LETTER_STAGGER_MS = 45;

const LoadingText: React.FC<{
  className?: string;
  letterClassName?: string;
  text: string;
}> = ({ className, letterClassName, text }) => (
  <span
    aria-label={text}
    className={`inline-flex text-secondary ${className || ""}`}
    role="status"
  >
    {Array.from(text).map((letter, index) => (
      <span
        aria-hidden="true"
        className={`animate-loading-text-letter-wave text-secondary-muted motion-reduce:animate-none ${letterClassName || ""}`}
        key={`${letter}-${index}`}
        style={{ animationDelay: `${index * LETTER_STAGGER_MS}ms` }}
      >
        {letter === " " ? "\u00a0" : letter}
      </span>
    ))}
  </span>
);

export default LoadingText;
